import {
  ActivityType,
  DataSource,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { usePolyglot } from "src/contexts"
import type { ReadOnlyUserEvent } from "src/types"

const polyglotPrefix = "components.activity_summary.source."

// note: this is only for events, not subentries
export type Props = ComponentPropsWithoutRef<"div"> & {
  item: ReadOnlyUserEvent;
}

const dataSourceValues: DataSource[] = Object.values(DataSource)
const skipForDataSources: DataSource[] = [DataSource.Tandem]
const skipForEventTypes: ActivityType[] = [
  ActivityType.Bolus,
  ActivityType.CGMSessionEnded,
  ActivityType.PumpSuspension,
]

export const ActivitySource = forwardRef<HTMLDivElement, Props>(
  function ActivitySource(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      item,
      ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    const children: string | null = useMemo(
      () => {
        const userEvent = item

        if (userEvent.source && skipForDataSources.includes(userEvent.source)) {
          return null
        }

        if (skipForEventTypes.includes(userEvent.event_type)) {
          return null
        }

        if (
          (userEvent.source === DataSource.AppleHealthKit ||
            userEvent.source === DataSource.AndroidHealthConnect) &&
          userEvent.source_subtype &&
          userEvent.source_subtype !== userEvent.source as string
        ) {
          return polyglot.t(
            `${polyglotPrefix}third_party_app`,
            {
              app: userEvent.source_subtype,
            },
          )
        }

        if (userEvent.source && dataSourceValues.includes(userEvent.source)) {
          return polyglot.t(`${polyglotPrefix}${userEvent.source}`)
        }

        return polyglot.t(`${polyglotPrefix}unknown`)
      },
      [
        polyglot,
        item,
      ],
    )

    if (!children) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {children}
      </div>
    )
  },
)
